import styled from 'styled-components';
import pulseKeyframes from '../../../styles/pulseKeyframes';
var PlaceholderContainer = styled.div.withConfig({
  displayName: "PlaceholderContainer",
  componentId: "sc-9himgv-0"
})(["animation:", " 1s infinite ease-in-out;"], pulseKeyframes);
export default PlaceholderContainer;